
import { defineStore } from 'pinia'


export const useUIStore = defineStore('loginDialog', {
  state: () => {
    return {
        loginDialogVisible: false
    }
  },
  actions: {
    showLoginDialog() {
        this.loginDialogVisible = true
    },
    hideLoginDialog() {
        this.loginDialogVisible = false
    }
  }
})
